export default "__VITE_ASSET__5b62caf8__"